var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.653 11.32.052.865-.867-.106c-3.156-.406-5.913-1.783-8.254-4.095L5.439 6.836l-.294.848c-.625 1.889-.226 3.883 1.075 5.225.693.742.537.848-.66.406-.415-.141-.78-.247-.814-.194-.122.124.294 1.73.624 2.366.45.882 1.37 1.747 2.376 2.26l.85.405-1.006.018c-.971 0-1.006.018-.902.389.347 1.147 1.717 2.365 3.243 2.895l1.075.37-.937.566a9.7 9.7 0 0 1-4.647 1.306c-.78.018-1.422.088-1.422.141 0 .177 2.116 1.165 3.347 1.554 3.694 1.147 8.081.653 11.376-1.307 2.341-1.394 4.682-4.166 5.774-6.85.59-1.43 1.18-4.042 1.18-5.296 0-.812.052-.918 1.023-1.889.572-.565 1.11-1.183 1.214-1.36.173-.335.156-.335-.729-.034-1.474.53-1.682.459-.953-.336.537-.565 1.179-1.589 1.179-1.889 0-.053-.26.035-.555.194-.312.177-1.006.442-1.526.6l-.936.3-.85-.582c-.469-.318-1.127-.67-1.474-.777-.885-.247-2.237-.212-3.035.07-2.168.795-3.538 2.843-3.382 5.085z",
    fill: "#4884E8",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.81f8d818.svg";
export { ForwardRef as ReactComponent };